import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';

import { companiesQueryKeys } from './queryKeys';

export interface CompanyStatsRange {
  /** Inclusive UTC instant, ISO string. */
  from: string;
  /** Exclusive UTC instant, ISO string. */
  to: string;
}

/**
 * `GET /companies/{id}/stats`: candidates waiting, interviews, LinkedIn
 * outreach and conversations needing review, for the dashboard greeting.
 */
export const useCompanyStatsQuery = (
  companyId: string | undefined,
  range: CompanyStatsRange,
) =>
  useQuery({
    queryKey: companiesQueryKeys.stats(companyId, range),
    queryFn: companyId
      ? async () => {
          const { data } = await fetchClient.GET(endpoints.companyStats, {
            params: { path: { id: companyId }, query: range },
          });
          return data;
        }
      : skipToken,
  });
